import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SpacesService } from '../../services/spaces.service';
import { PageHeaderComponent } from '../../components/page-header/page-header.component';
import { SpacesOverviewComponent } from '../../components/spaces-overview/spaces-overview.component';
import { Space } from '../../models/space.model';

@Component({
    selector: 'app-spaces',
  imports: [TranslateModule, PageHeaderComponent, SpacesOverviewComponent],
    templateUrl: './spaces.component.html',
    styleUrl: './spaces.component.scss'
})
export class SpacesComponent implements OnInit {
  spaces: Space[] = [];
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly spacesService: SpacesService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.spacesService.spaces$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(spaces => {
      this.spaces = spaces;
    });
  }

  get hasSpaces(): boolean {
    return this.spaces.length > 0;
  }

  onViewDetails(space: Space): void {
    this.router.navigate(['/spaces', space.id]);
  }
}
